<template>
<div>
    <p>A little site by Brandon Gonzalez. Engineer that knows too much about distributed systems, ferment enthusiast, aspiring trad dad. Senior software engineer at <a href="https://chronosphere.io">Chronosphere</a>. Previously at <a href="https://lightstep.com">Lightstep</a> and intern at <a href="http://iron.io">iron.io</a>.</p>

    <div>
        Built using:
        <ul>
            <li> <a href='https://vuejs.org/'>Vue.js</a></li>
            <li> Github pages (free) </li>
            <li> Google Domains ($12/year) </li>
            <li> Logo by <a href='https://instagram.com/lutradamus'>Chris Botto</a> ($25)</li>
        </ul>
    </div>
</div>
</template>


<script>
const name = 'About';

export default {
    name,
}
</script>
